import axios from '../plugins/axios'
import { Module } from 'vuex'

const enrichModule: Module<any, any> = {
    actions: {
        async enrichUser(_, { payload, profileUuid }) {
            try {
                const { data } = await axios.put(
                    `/api/public_social_data/profile/${profileUuid}/enrich`,
                    payload,
                    { raw: true } as any,
                )
                return data
            } catch (e: any) {
                const detail = e?.response?.data?.error?.detail ?? e?.message ?? 'Failed to schedule user enrichment job. Please try again.'
                throw { detail }
            }
        },
    },
}

export default enrichModule
